export enum QueryKey {
  AUTH_USER = "auth-user",
  RUNNING_JOBS = "running-jobs",
  COMPANY_AFFILIATION = "company-affiliation",
  CALLS = "calls",
  CALL_ANALYSIS_WORKSPACE = "call-analysis-workspace",
  HAS_ANALYSED_CALL = "has-analysed-call",
  PROJECT_INSIGHTS = "project-insights",
  INSIGHT_CALLS = "insight-calls",
  CATEGORY_INSIGHTS = "category-insights",
  ADMIN_USERS = "admin-users",
  ADMIN_USER = "admin-user",
  ADMIN_LLM_COSTS = "admin-llm-costs",
  PROJECT_PATTERNS = "project-patterns",
  PROJECT_RECOMMENDATIONS = "project-recommendations",
  PROJECT_OFFER = "project-offer",
  PROJECT_OVERVIEW = "project-overview",
  ANALYSED_CALLS = "analysed-calls",
  PROJECT_BY_UUID = "project-by-uuid",
  CLIENT_AVATAR = "client-avatar",
  CLIENT_AVATAR_BOOTSTRAP = "client-avatar-bootstrap",
  HAS_PROJECT_INSIGHTS = "has-project-insights",
  PROJECT_MEMBERS = "project-members",
  PROJECT_EDIT_ACCESS = "project-edit-access",
  PROJECT_INVITATIONS = "project-invitations",
  PROJECT_CALL_TYPES = "project-call-types",
  PROSPECT_CRITERIA = "prospect-criteria",
  PROSPECT_SEARCH_SUMMARY = "prospect-search-summary",
  PROSPECT_SEARCH_WORKSPACE = "prospect-search-workspace",
  PROSPECT_SEARCH_BOOTSTRAP = "prospect-search-bootstrap",
  MESSAGES_CONTENT_BOOTSTRAP = "messages-content-bootstrap",
  SCRIPT = "script",
  SCRIPT_SUMMARY = "script-summary",
  OFFERS_BOOTSTRAP = "offers-bootstrap",
  CALL_ANALYSIS_OVERVIEW = "call-analysis-overview",
  PROJECT_WORKSPACE = "project-workspace",
  MESSAGE_SEQUENCE = "message-sequence",
  SEQUENCE_OBJECTIVE = "sequence-objective",
  PROSPECT_CONVERSATION = "prospect-conversation",
  PROSPECT_ORDER_PENDING = "prospect-order-pending",
  PROSPECT_ORDERS = "prospect-orders",
  CLIENT_PROSPECTS = "client-prospects",
  CLIENT_PROSPECT_DETAIL = "client-prospect-detail",
  PROSPECT_ACTIONS = "prospect-actions",
  PROSPECT_ACTION_TYPES = "prospect-action-types",
  SOCIAL_IMPORTED_PROFILE_COUNTS = "social-connection-counts",
  USER_IMPORTED_PROFILES = "user-connections",
  IMPORTED_BASE = "imported-base",
  PROSPECT_FEED_MEMBERS = "prospect-feed-members",
  PROSPECTING_STATS = "prospecting-stats",
  IMPORTED_PROFILE_DETECTION_REMAINING = "connection-detection-remaining",
  AGENT_SEARCHES = "agent-searches",
  AGENT_SEARCHES_BOOTSTRAP = "agent-searches-bootstrap",
  AGENT_DONE_SEARCHES = "agent-done-searches",
  AGENT_POTENTIAL_SEARCHES = "agent-potential-searches",
  AGENT_SEARCH_DETAIL = "agent-search-detail",
  AGENT_PROSPECTS = "agent-prospects",
  AGENT_PROSPECT_DETAIL = "agent-prospect-detail",
  AGENT_POTENTIAL_MATCHES = "agent-potential-matches",
  FAILED_JOBS = "failed-jobs",
  SUBSCRIPTION = "subscription",
  HAS_MCP_TOKEN = "has-mcp-token",
  HAS_EXTENSION_TOKEN = "has-extension-token",
}

export enum QueryTypeFilter {
  ACTIVE = "active",
  INACTIVE = "inactive",
  ALL = "all",
}

export enum AvatarQuerySubKey {
  DETAIL = "detail",
  ABOUT = "about",
  PAIN = "pain",
  SITUATION = "situation",
  OBJECTIONS = "objections",
  VERBATIMS = "verbatims",
  FIT = "fit",
  FRESHNESS = "freshness",
}
